/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from "react";
import { RoleGate } from "./components/role-gate";
import { Loading } from "./components/ui/loading";
import { ROLE } from "./utils/constant";
import { keycloak } from "./utils/lib/keycloak";

// Microfrontends

// Rebuild Module
const MasterProfileIndex = lazy(() => import("rebuild/MasterProfileIndex"));
const MasterProfileDetail = lazy(() => import("rebuild/MasterProfileDetail"));
const MasterProfileCreate = lazy(() => import("rebuild/MasterProfileCreate"));
const MasterProfileLogHistory = lazy(
  () => import("rebuild/MasterProfileLogHistory"),
);

export const rebuildRoutes = [
  {
    path: "master-profile",
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.ADMINISTRATOR]}>
              <MasterProfileIndex keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: ":id",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.ADMINISTRATOR]}>
              <MasterProfileDetail keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.ADMINISTRATOR]}>
              <MasterProfileCreate keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "log-history/:id",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.ADMINISTRATOR]}>
              <MasterProfileLogHistory keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
    ],
  },
];
